<div
  *ngIf="showImportingSpinner && !(columns && columns.length > 0)"
  class="importing-spinner"
>
  <div class="spinner-border text-primary" role="status"></div>
  <h1 class="text-primary mt-3">{{ importStopsStatus }}...</h1>
</div>
<tmx-csv-importer
  [ngClass]="{
    hide: columns && columns.length > 0 ? true : showImportingSpinner
  }"
  [configuration]="configuration"
  [hostEvent]="hostEvent!"
  (eventChange)="handleEvent($event)"
></tmx-csv-importer>

<div *ngIf="columns && columns.length > 0" class="d-flex flex-row m-2">
  <div class="search-component mr-2">
    <div class="input-with-icon-left">
      <input
        type="text"
        [(ngModel)]="searchText"
        name="searchText"
        class="form-control"
        id="searchTextId"
        placeholder="Search By Address"
      />
      <div class="input-icon">
        <i class="modus-icon material-icons">search</i>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div
      class="chip chip-outline chip-filter ml-2"
      *ngIf="hasExactMatches"
      (click)="getStopsByMatchType('exact')"
    >
      <div class="chip-icon-left" *ngIf="searchType === 'exact'">
        <i class="modus-icons notranslate" aria-hidden="true">check</i>
      </div>
      <div class="chip-text">Exact</div>
    </div>

    <div
      class="chip chip-outline chip-filter ml-2"
      *ngIf="hasGoodMatches"
      (click)="getStopsByMatchType('good')"
    >
      <div class="chip-icon-left" *ngIf="searchType === 'good'">
        <i class="modus-icons notranslate" aria-hidden="true">check</i>
      </div>
      <div class="chip-text">Good</div>
    </div>
    <div
      class="chip chip-outline chip-filter ml-2"
      *ngIf="hasUncertainMatches"
      (click)="getStopsByMatchType('uncertain')"
    >
      <div class="chip-icon-left" *ngIf="searchType === 'uncertain'">
        <i class="modus-icons notranslate" aria-hidden="true">check</i>
      </div>
      <div class="chip-text">Uncertain</div>
    </div>

    <div
      class="chip chip-outline chip-filter ml-2"
      *ngIf="hasFailedMatches"
      (click)="getStopsByMatchType('failed')"
    >
      <div class="chip-icon-left" *ngIf="searchType === 'failed'">
        <i class="modus-icons notranslate" aria-hidden="true">check</i>
      </div>
      <div class="chip-text">Failed</div>
    </div>
  </div>
</div>
<table
  class="table table-bordered table-hover custom-table"
  *ngIf="columns && columns.length > 0"
>
  <thead class="table-primary">
    <tr>
      <th scope="col">Row</th>
      <th scope="col">Match</th>
      <th scope="col" *ngIf="importedDataHasAddress">Input Address</th>
      <th scope="col">Match Address</th>
      <th scope="col" style="width: 200px" *ngIf="importedDataHasLatLon">
        Input Lat Lon
      </th>
      <th>
        <div class="custom-control custom-checkbox">
          <input
            id="skipAll"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="isAllCheckBoxChecked"
            (change)="skipAllCheckBox($event)"
          />
          <label class="custom-control-label" for="skipAll"></label>
          <span class="overlay">Skip All</span>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="
        let column of columns | searchByAddress : searchText : searchType;
        let i = index
      "
      tabindex="{{ 300 + $index }}"
    >
      <td [attr.colspan]="column?.row === 'No Match Results Found' ? 5 : 0">
        {{ column?.row }}
      </td>
      <td *ngIf="column?.row !== 'No Match Results Found'">
        {{ column?.match }}
      </td>
      <td
        *ngIf="
          importedDataHasAddress && column?.row !== 'No Match Results Found'
        "
      >
        {{ column?.inputAddress }}
      </td>
      <td *ngIf="column?.row !== 'No Match Results Found'">
        {{ column?.matchAddress }}
      </td>
      <td
        style="width: 200px"
        *ngIf="
          importedDataHasLatLon && column?.row !== 'No Match Results Found'
        "
      >
        {{ column?.inputLatLon }}
      </td>
      <td style="width: 150px" *ngIf="column?.row !== 'No Match Results Found'">
        <div class="custom-control custom-checkbox">
          <input
            id="skipStop{{ i }}"
            type="checkbox"
            class="custom-control-input"
            [checked]="column?.checked"
            (change)="handleCheckboxChange($event, column)"
          />
          <label class="custom-control-label" for="skipStop{{ i }}"></label>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div
  *ngIf="!showImportingSpinner && succeeded && !errored"
  class="alert alert-success show"
  role="alert"
>
  <i class="material-icons alert-icon notranslate">check</i>
  <div>{{ successMessage }}</div>
</div>
<div
  *ngIf="!showImportingSpinner && errored && !(errorData || warningData)"
  class="alert alert-danger show"
  role="alert"
>
  <i class="material-icons alert-icon notranslate">warning</i>
  <div>{{ errorMessage }}</div>
</div>
<div
  *ngIf="
    !showImportingSpinner &&
    (errorData || warningData) &&
    !errorWhenProcessingRevGeo
  "
  class="alert alert-success show"
  role="alert"
>
  <i class="material-icons alert-icon notranslate">info</i>
  <div>Click continue to import stops</div>
</div>
<ul
  class="list-group m-2"
  *ngIf="!showImportingSpinner && (errorData || warningData)"
>
  <li
    class="list-group-item py-0"
    *ngIf="!showImportingSpinner && warningData && unCertainRows?.length > 0"
  >
    <div class="accordion borderless w-100" id="listAccordion">
      <div class="card">
        <div
          class="card-header px-0"
          role="button"
          id="listAccordionHeading"
          data-toggle="collapse"
          data-target="#listAccordionOne"
          aria-expanded="false"
          aria-controls="listAccordionOne"
        >
          <h6 class="mb-0" id="collapsible-list-item">Warnings</h6>
        </div>
        <div
          id="listAccordionOne"
          class="collapse"
          aria-labelledby="listAccordionHeading"
          data-parent="#listAccordion"
        >
          <div class="card-body">
            <div class="alert alert-warning show" role="alert">
              <ul>
                <li *ngFor="let unCertainRow of unCertainRows">
                  {{ unCertainRow }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
  <li
    class="list-group-item py-0"
    *ngIf="!showImportingSpinner && errorData && invalidRows?.length > 0"
  >
    <div class="accordion borderless w-100" id="listAccordion">
      <div class="card">
        <div
          class="card-header px-0"
          role="button"
          id="listAccordionHeading"
          data-toggle="collapse"
          data-target="#listAccordionTwo"
          aria-expanded="false"
          aria-controls="listAccordionTwo"
        >
          <h6 class="mb-0" id="collapsible-list-item">Errors</h6>
        </div>
        <div
          id="listAccordionTwo"
          class="collapse"
          aria-labelledby="listAccordionHeading"
          data-parent="#listAccordion"
        >
          <div class="card-body">
            <div class="alert alert-danger show" role="alert">
              <ul>
                <li *ngFor="let invalidRow of invalidRows">
                  {{ invalidRow }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</ul>
